<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <h1>
          {{ $tc('models.waybill', 2) }}
          <v-btn color="primary" @click="back" flat> {{ $t('back') }} </v-btn>
          <v-btn color="primary" @click="save" outline v-if="inputFile"> {{ $t('save') }} </v-btn>
        </h1>
      </v-flex>

      <v-flex xs12>
        <v-card>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12 md4>
                <v-text-field :label="$t('selectFile')" @click="pickFile" v-model="filename" prepend-icon="attach_file"></v-text-field>
                <input type="file" style="display: none" ref="file" accept="*/*" @change="onFilePicked">
              </v-flex>

              <v-flex xs12 md4>
                <v-select v-model="carrierId"
                          :items="carriers"
                          item-value="id"
                          item-text="name"
                          :label="$tc('models.carrier')"
                          clearable
                          ></v-select>
              </v-flex>

              <v-flex xs12 md4>
                <v-select v-model="serviceId"
                          :items="filteredServices"
                          item-value="id"
                          item-text="name"
                          :label="$tc('models.service')"
                          :disabled="!carrierId"
                          clearable
                          ></v-select>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12>
        <v-data-table class="elevation-1"
                      :headers="headers"
                      :items="importedWaybills"
                      :loading="loading"
                      hide-actions
                      :no-data-text="$t('noDataAvailable')">
          <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
          <template v-slot:items="props">
            <td> {{ props.item.number }} </td>
            <td> {{ props.item.error }} </td>
            <td class="pa-0 pr-2 text-xs-center">
              <font-awesome-icon icon="clock" v-if="props.item.status === 'pending'"></font-awesome-icon>
              <font-awesome-icon icon="check" v-if="props.item.status === 'success'"></font-awesome-icon>
              <font-awesome-icon icon="times" v-if="props.item.status === 'error'"></font-awesome-icon>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import XLSX from 'xlsx'

import Carrier from '@/client/carrier'
import Service from '@/client/service'
import Waybill from '@/client/waybill'

export default {
  name: 'ImportWaybillsView',

  props: {},

  data () {
    return {
      filename: '',
      inputFile: '',

      headers: [
        { text: this.$t('attrs.number'), align: 'left', sortable: true, value: 'name' },
        { text: this.$t('error'), align: 'left', sortable: true, value: 'error' },
        { text: this.$t('attrs.status'), align: 'left', sortable: true, value: 'status', width: '5%' }
      ],
      loading: false,
      importedWaybills: [],

      carrierId: '',
      serviceId: '',

      carriers: [],
      services: []
    }
  },

  components: {
  },

  computed: {
    filteredServices () {
      if (!this.carrierId) { return [] }

      return this.services.filter(o => Number(o.carrier_id) === Number(this.carrierId))
    }
  },

  methods: {
    onFilePicked (e) {
      this.loading = true
      this.errors.clear()
      this.importedWaybills = []

      this.inputFile = e.target.files[0]
      this.filename = this.inputFile.name

      const extensions = ['csv', 'xls', 'xlsx']
      const ext = this.filename.split('.').pop()
      if (extensions.indexOf(ext) === -1) {
        this.errors.add('', 'Invalid file type!')
        return
      }

      const reader = new FileReader()
      reader.onload = (e) => {
        const data = e.target.result
        const wb = XLSX.read(data, { type: 'binary' })
        wb.SheetNames.forEach(sn => {
          let res = XLSX.utils.sheet_to_json(wb.Sheets[sn])
          this.importedWaybills = res.map(o => {
            return new Waybill({ number: o['number'], status: 'pending' })
          })
          this.loading = false
        })
      }

      reader.readAsBinaryString(this.inputFile)
    },

    pickFile () {
      this.$refs.file.click()
    },

    async save () {
      if (!this.carrierId) { return }

      for (let wb of this.importedWaybills) {
        wb.carrier_id = this.carrierId
        wb.service_id = this.serviceId
        try {
          await wb.save()
          this.$set(wb, 'status', 'saved')
        } catch (err) {
          this.$set(wb, 'status', 'error')
          this.$set(wb, 'error', err.response.data.messages[0])
        }
      }
    }
  },

  watch: {
  },

  async mounted () {
    this.carriers = await Carrier.all({ per_page: 2000 })
    this.services = await Service.all({ per_page: 2000 })
  }
}
</script>
